import React from 'react';
import { X, Star } from 'lucide-react';
import type { Consultant } from '../../../types/consultant';

interface ConsultantChatHeaderProps {
  consultant: Consultant;
  onClose: () => void;
}

export const ConsultantChatHeader: React.FC<ConsultantChatHeaderProps> = ({
  consultant,
  onClose
}) => {
  return (
    <div className="p-4 border-b border-purple-500/20 bg-indigo-950/50">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {consultant.imageUrl ? (
            <img
              src={consultant.imageUrl}
              alt={consultant.name}
              className="w-12 h-12 rounded-full object-cover"
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-purple-500/30 flex items-center justify-center text-lg text-purple-200">
              {consultant.name.charAt(0).toUpperCase()}
            </div>
          )}
          <div>
            <h3 className="text-lg font-medium text-purple-200">
              {consultant.name}
            </h3>
            <p className="text-sm text-purple-200/70">
              {consultant.specialty}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="flex items-center text-yellow-400">
            <Star className="w-4 h-4 mr-1" />
            <span>{consultant.rating}</span>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-purple-200" />
          </button>
        </div>
      </div>
    </div>
  );
};